import { FC, memo } from 'react'

import { LinearProgressProps } from './LinearProgress.types'

import { s } from './styles'

export const LinearProgress: FC<LinearProgressProps> = memo((props) => {
  const { 'data-qa': dataQA, value, showCounter } = props
  const safeValue = value !== undefined ? Math.round(Math.min(Math.max(value, 0), 100)) : undefined

  const component = (
    <s.box data-qa={dataQA}>
      <s.track>
        <s.bg />
        <s.fg style={{ width: `${safeValue}%` }} />
      </s.track>
      {showCounter && <s.label>{safeValue}%</s.label>}
    </s.box>
  )

  return component
})
